import { ReactNode } from 'react';
import { useActiveFeatureFlags } from 'posthog-js/react';
import { DEFAULT_ENABLED_FEATURE_FLAGS, FeatureFlag } from '@bariendo/lib/constants';
import { FeatureFlagsContext } from './contexts';

interface FeatureFlagsProviderProps {
  children: ReactNode;
}

/**
 * Provider that fetches all feature flags once and shares them across the app
 * This prevents multiple PostHog API calls and rate limiting issues
 */
export function FeatureFlagsProvider({ children }: FeatureFlagsProviderProps) {
  // Import all available feature flags
  const flags = useActiveFeatureFlags();

  const flagsMap = flags.reduce((obj, flag) => ({ ...obj, [flag]: true }), {} as Record<string, boolean>);

  // Flags PostHog does not report fall back to their default, so the fully rolled-out ones
  // stay on before flags load and while PostHog is unreachable.
  const isEnabled = (flag: FeatureFlag): boolean => {
    return flagsMap[flag] ?? DEFAULT_ENABLED_FEATURE_FLAGS.has(flag);
  };

  return <FeatureFlagsContext.Provider value={{ flagsMap, isEnabled }}>{children}</FeatureFlagsContext.Provider>;
}
